// ** Custom Menu Components
import VerticalNavLink from './VerticalNavLink'
import VerticalNavGroup from './VerticalNavGroup'
import VerticalNavSectionTitle from './VerticalNavSectionTitle'
import { useAuth } from 'src/hooks/useAuth'
import { useEffect, useState } from 'react'

const resolveNavItemComponent = item => {
  if (item.sectionTitle) return VerticalNavSectionTitle
  if (item.children) return VerticalNavGroup

  return VerticalNavLink
}

const parseManageAccess = manageAccess => {
  const accessMap = {}
  manageAccess?.split(',').forEach(access => {
    const [section, permissions] = access?.split('[')
    const sectionName = section?.trim()?.toLowerCase()
    accessMap[sectionName] = permissions?.replace(']', '')?.trim()
  })

  return accessMap
}

const getAccessibleNavItems = (user, navItems) => {
  const manageAccess = user?.manage_access || ''
  const accessMap = parseManageAccess(manageAccess)

  return navItems?.filter(item => {
    if (user?.role === 'super_admin') {
      return true
    }

    const sectionName = item?.title.toLowerCase()

    const hasAccessToParent = Object.keys(accessMap)?.some(accessKey => {
      const normalizedAccessKey = accessKey.toLowerCase()
      return sectionName === normalizedAccessKey
    })

    if (hasAccessToParent) {
      console.log(`Access granted to parent: ${item.title}`)

      if (item.children) {
        item.children = item.children.filter(child => {
          // Optional: Add specific logic for child permission validation if needed
          console.log('Granting access to child:', child.title)
          return true // Ensure child is returned here
        })
      }

      return true
    }

    return false
  })
}

const VerticalNavItems = props => {
  // ** Props
  const { verticalNavItems } = props
  const { user } = useAuth()
  const [accessibleNavItems, setAccessibleNavItems] = useState([])
  useEffect(() => {
    const updatedAccessibleNavItems = getAccessibleNavItems(user, verticalNavItems)

    setAccessibleNavItems(updatedAccessibleNavItems)
  }, [user, verticalNavItems])

  const RenderMenuItems = verticalNavItems?.map((item, index) => {
    const TagName = resolveNavItemComponent(item)
    return <TagName {...props} key={index} item={item} />
  })

  return <>{RenderMenuItems}</>
}

export default VerticalNavItems
